import { useParams } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import FormEventNew from "../../components/forms/FormEventNew/FormEventNew";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import {
  useFetchEventQuery,
  useFetchSitesQuery,
} from "../../features/api/apiSlice";
import { isDev } from "../../utils/dev";
import styles from "./PageEventEdit.module.scss";

const PageEventEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data: eventData, isFetching } = useFetchEventQuery(Number(id), {
    skip: !id,
  });

  const { data: sitesData, isFetching: isFetchingSites } = useFetchSitesQuery();

  if (isDev) {
    console.log("eventData", eventData);
    console.log("sitesData", sitesData);
  }

  // const pilote = pilotes?.find((user) => user.id === eventData?.pilotes[0]?.id);
  // const hasPilote = Boolean(pilote);

  const isPageLoading = isFetching || isFetchingSites;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="event"
        eventId={eventData?.id}
        eventName={eventData?.name}
      />
      {isPageLoading && <h1>Loading..</h1>}
      {!!eventData && (
        <FormEventNew sites={sitesData?.results} isEditMode event={eventData} />
      )}
    </PageLayout>
  );
};

export default PageEventEdit;
